import {ACTION_TYPE} from "utils/constants";

const GO_BTN_UUID = "0cdf9a1b-3b94-4cea-a7f8-94c52c96be39";
const BACK_BTN_UUID = "9f07ee0b-1ac6-4b3a-9403-6e9b2a4f1534";
const RIGHT_BTN_UUID = "1b864dde-83c1-4d65-a6f7-2648447bb88f";
const LEFT_BTN_UUID = "ff203086-43b9-4769-8237-1a0e208ddbf7";
const CAR_UUID = "a86f2099-c167-42de-b3ad-effd5a10410e";
const DONUT_UUID = "0623b775-945a-4855-b0ba-cf187d861b73";

let newAssetCreated = false;
let isPublished = false;

export function _onInit() {
  this.ctx.addEventListener(ACTION_TYPE.OBJECT_ADDED, e => {
    if (this.missionIndex === 5) {
      newAssetCreated = true;
    }
  });
  this.ctx.addEventListener(ACTION_TYPE.CHANGE_PROGRESS, e => {
    if (this.missionIndex === 5 && e.detail.object === 100) {
      isPublished = true;
    }
  });
}

export function _onPlayStart() {
  let stepSuccess = false;
  const {oobcJSON, script} = this.ctx.sceneEdit.userData;

  switch (this.missionIndex) {
    case 0:
      // if (script?.includes(`this.getSprite("0").onCollide("${GO_BTN_UUID}", function() {\n\tthis.getSprite("${CAR_UUID}").moveX(20)\n})`))
      if (searchOobcJson(oobcJSON, "0", GO_BTN_UUID, CAR_UUID, "move", "x", 20)) {
        stepSuccess = true;
      }
      break;
    case 1:
      if (searchOobcJson(oobcJSON, "0", BACK_BTN_UUID, CAR_UUID, "move", "x", -20)) {
        stepSuccess = true;
      }
      break;
    case 2:
      if (
        searchOobcJson(oobcJSON, "0", RIGHT_BTN_UUID, CAR_UUID, "turn", "y", -90) &&
        searchOobcJson(oobcJSON, "0", RIGHT_BTN_UUID, CAR_UUID, "move", "z", 20)
      ) {
        stepSuccess = true;
      }
      break;
    case 3:
      if (
        searchOobcJson(oobcJSON, "0", LEFT_BTN_UUID, CAR_UUID, "turn", "y", 90) &&
        searchOobcJson(oobcJSON, "0", LEFT_BTN_UUID, CAR_UUID, "move", "z", -20)
      ) {
        stepSuccess = true;
      }
      break;
    case 4:
      if (searchOobcJson(oobcJSON, CAR_UUID, DONUT_UUID, DONUT_UUID, "kill")) {
        stepSuccess = true;
      }
      break;
    case 5:
      if (
        (script?.includes("onCollideOnce") || script?.includes("onCollide")) &&
        script?.includes("kill") &&
        newAssetCreated &&
        isPublished
      ) {
        stepSuccess = true;
      }
      break;
    default:
      break;
  }
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent(stepSuccess ? ACTION_TYPE.TUTORIAL_MISSION_SUCCESS : ACTION_TYPE.TUTORIAL_MISSION_FAIL));
  }, 5000);
}

export function _onPlayEnd() {}

export function _onPlaying() {}

export function _onReset() {
  newAssetCreated = false;
  isPublished = false;
}

function searchOobcJson(oobcJson, subjectUuid, hitUuid, apiSubjectUuid, apiName, axis, number) {
  const lines = oobcJson.lines;
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const subject = line.block;
    if (subject.uuid !== subjectUuid) continue;

    for (let j = 0; j < subject.children.length; j++) {
      const onCollideApi = subject.children[j];
      if (onCollideApi.data !== "onCollide") continue;
      const [hit, callbacks] = onCollideApi.children;
      if (hit.uuid !== hitUuid) continue;
      if (callbacks.constructor !== "Callback") continue;

      for (let k = 0; k < callbacks.children.length; k++) {
        const callback = callbacks.children[k];
        const apiSubject = callback.block;
        if (apiSubject.uuid !== apiSubjectUuid) continue;

        for (let l = 0; l < apiSubject.children.length; l++) {
          const api = apiSubject.children[l];
          if (api.data !== apiName) continue;

          if (apiName === "move" || apiName === "turn") {
            if (api.children[0].data !== axis) continue;
            if (api.children[1].data === number) return true;
          } else if (apiName === "kill") {
            return true;
          }
        }
      }
    }
  }
  return false;
}
